module.exports = __webpack_public_path__ + "static/img/presysv78.1f988a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/presysv78.png
// module id = EM64
// module chunks = 1